<template>
  <div>
    <v-app-bar 
      app 
      color="white" 
      light 
      elevation="1" 
      dense 
      height="64"
      :class="{'desktop-content': true}"
    >
      <!-- Mobile Menu Toggle REMOVED -->

      <!-- Page Title -->
      <div class="page-title ml-4">
        <h1>{{ currentRouteName }}</h1>
      </div>

      <v-spacer />

      <!-- Date & Time -->
      <div class="date-time-container d-none d-sm-flex mr-6">
        <div class="dt-item">
          <v-icon small color="grey darken-1" class="mr-1">mdi-calendar-blank</v-icon>
          <span>{{ date }}</span>
        </div>
        <div class="dt-divider mx-3"></div>
        <div class="dt-item">
          <v-icon small color="grey darken-1" class="mr-1">mdi-clock-time-four-outline</v-icon>
          <span>{{ time }}</span>
        </div>
      </div>

      <!-- User Info -->
      <div class="user-info d-flex align-center mr-4">
        <div class="text-right">
          <div class="user-name">{{ $store.getters.getUserData.user_login || 'Usuário' }}</div>
          <div class="user-role">{{ $store.getters.getUserData.role_name || 'Administrador' }}</div>
        </div>
      </div>

      <!-- Logout Button -->
      <div class="logout-section pl-4" style="border-left: 1px solid #eee">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon color="grey darken-1" v-bind="attrs" v-on="on" @click="logOut">
              <v-icon>mdi-logout</v-icon>
            </v-btn>
          </template>
          <span>Sair do sistema</span>
        </v-tooltip>
      </div>

      <v-progress-linear
        :active="$store.getters.getLoader"
        :indeterminate="$store.getters.getLoader"
        absolute
        bottom
        color="secondary"
      ></v-progress-linear>
    </v-app-bar>
    <Menu />
  </div>
</template>

<script>
import Menu from "./Menu.vue";
export default {
  components: {
    Menu,
  },
  data: () => ({
    date: "",
    time: "",
  }),
  computed: {
    currentRouteName() {
      // Map common routes to display names or use route name directly
      const name = this.$route.name;
      // You can add a mapping object here if route names are technical (e.g., 'home' -> 'DASHBOARD')
      return name ? name : 'DASHBOARD'; 
    }
  },
  created() {
    this.initilizeTime();
  },  
  methods: {
    menu() {
      this.$store.dispatch("activeMenu", !this.$store.getters.getMenuState);
    },
    logOut() {
      let c = confirm("Deseja sair do sistema?");
      if (c) {
        localStorage.removeItem("userData");
        localStorage.removeItem("vuex");
        localStorage.removeItem("token");
        this.$router.replace("/login");
      }
    },
    initilizeTime() {
      this.date = new Date().toLocaleDateString("pt-br");
      setInterval(() => {
        let time = new Date().toLocaleTimeString("pt-br");
        // Remove seconds for cleaner look if desired, keeping consistent with request
        this.time = time;
      }, 1000);
    },
  },
};
</script>

<style scoped>
.page-title h1 {
  font-size: 1.25rem;
  font-weight: 900;
  font-style: italic;
  text-transform: uppercase;
  color: #333;
  letter-spacing: 0.5px;
}

.date-time-container {
  display: flex;
  align-items: center;
  color: #666;
  font-size: 0.9rem;
  font-weight: 500;
}

.dt-item {
  display: flex;
  align-items: center;
}

.dt-divider {
  width: 1px;
  height: 16px;
  background-color: #ddd;
}

.user-name {
  font-weight: 700;
  color: #333;
  font-size: 0.85rem;
  text-transform: uppercase;
  line-height: 1.2;
}

.user-role {
  font-size: 0.7rem;
  color: #FF4600; /* Using the orange accent color for role */
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

/* Search bar placeholder style */
.search-bar {
  background-color: #f5f5f5;
  padding: 8px 16px;
  border-radius: 20px;
  align-items: center;
  width: 250px;
}
</style>

// Este e o header da aplicacao. Possui o metodo menu onde e passado a uma variavel global (VUEX) para gerenciar a abertura e fechamento do menu.

esta funcao e uma action que e responsavel por atualizar o menu com o seu valor invertido.
this.$store.dispatch("activeMenu", !this.$store.getters.getMenuState);

foi importado um componente chamado Menu.